import React from 'react';

import { IonCol, IonGrid, IonRow } from '@ionic/react';

import get from 'lodash/get';

import { DescriptionItem, DescriptionList } from 'components/DescriptionList';

const LegalContactPerson = ({ data }: { data: any }) => {
  return (
    <DescriptionList data={get(data, 'publisher.legalContact')}>
      <IonGrid>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem
              valueParser={({ firstName, lastName } = {}) =>
                `${firstName} ${lastName}`
              }
              label={'Name'}
            />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem field={'email'} label={'Email'} />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem field={'phone'} label={'Phone'} />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem field={'imAddress'} label={'Skype'} />
          </IonCol>
        </IonRow>
      </IonGrid>
    </DescriptionList>
  );
};

export default LegalContactPerson;
